<template>
  <div :class="'md-flex md-layout-item'">
    <div :class="'md-layout-item md-size-55'">
      <span :class="'md-body-1'" v-bind:style="answered ? '' : 'color: #ef4225;' ">{{ text }}</span>
    </div>
    <div :class="'md-layout-item md-size-15'">
      <md-radio
        @change="send"
        v-model="field"
        v-for="(option, i) in question.options"
        :disabled="isDisabled"
        :value="option.id"
        :key="i"
      >
        {{ option.text }}
      </md-radio>
    </div>
    <div :class="'md-layout-item md-size-30'">
      <md-field>
        <label>Observation</label>
        <md-input
          type="text"
          v-model="observation"
          :disabled="isDisabled"
          :maxlength="100"
          @blur.prevent="send"
        />
      </md-field>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    review: {
      type: Object,
      required: true,
    },
    question: {
      type: Object,
      required: true,
    },
    answer: {
      type: Object,
      required: true,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    answered: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      text: "",
      field: "",
      observation: "",
    };
  },
  methods: {
    send() {
      const id = this.$route.params.id;
      const data = this.getAnswer();

      this.$api.request
        .post(`reviews/${id}/answers`, data)
        .then((response) => {
          this.$emit("post-sent", {
            question: this.question.id || response.data[0]["question_id"],
          });
        })
        .catch(() => {
          this.$toast.warning("Please, try again.", "");
        });
    },
    getAnswer() {
      return {
        section: this.getSection(),
        type: this.question.type,
        answers: [
          {
            question_id: this.question.id,
            option_id: this.field,
            text: this.observation,
          },
        ],
      };
    },
    getSection() {
      switch (this.$parent.mdLabel) {
        case "Engagement Leader":
          return "engagement_leader";
        case "Manager":
          return "manager";
        default:
          return "reviewer";
      }
    },
  },
  mounted() {
    this.text = this.question.text;
    this.field = this.answer.option_id;
    this.observation = this.answer.text;
  },
};
</script>
